var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 455.9 455.9" },
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 455.9 455.9",
        "xml:space": "preserve",
        id: _vm.id,
      },
    },
    [
      _c("svg:style", { attrs: { type: "text/css" } }, [
        _vm._v(
          "\n            #" +
            _vm._s(_vm.id) +
            " > .b3-st0 {\n                fill: " +
            _vm._s(_vm.color) +
            ";\n            }\n            #" +
            _vm._s(_vm.id) +
            " > .b3-st1 {\n                fill: #ffffff;\n            }\n        "
        ),
      ]),
      _vm._v(" "),
      _c("circle", {
        staticClass: "b3-st0",
        attrs: { cx: "228", cy: "228", r: "228" },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "b3-st1",
        attrs: {
          d: "M218.3,114.7c-63,0-114.1,41.6-114.1,92.8c0,23.8,11,45.6,29.2,62c-5,41.6,23.5,67.4,23.5,67.4\n\tc-3.4-14.7,9.8-30.3,23.1-41.9c12.5,3.6,25.4,5.4,38.3,5.3c63,0,114.2-41.6,114.2-92.8S281.4,114.7,218.3,114.7z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "b3-st1",
        attrs: {
          d: "M378,265.3c0-20.4-15-38-37-46.9c-2.8,39.7-36.2,72.8-81.5,83.7c12.5,9.9,30.1,16,49.5,16c7.8,0,15.6-1,23.2-3\n\tc8.1,6.6,16,15.5,14,23.9c0,0,17.2-14.7,14.2-38.4C371.3,291.2,378,278.9,378,265.3z",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }